<div class="main-container">
    <div class="main-content">
      <!-- Document Type Cards -->
      <div class="document-cards">
        <div *ngFor="let card of documentCategories" 
             class="document-card" (click)="onCategoryClick(card)"
             [class.selected]="card.isActive"
            >
          <div class="card-content">
            <span class="title">{{card.title}}</span>
            <!-- <span class="subtitle">Documents</span> -->
            <div class="count-container">
              <span class="count">{{card.count}}</span>
              <!-- <div [class]="'icon-container ' + card.icon">
                <i class="material-icons">{{card.icon}}</i>
              </div> -->
              <div class="icon-container">
                <img [src]="card.image" alt="{{card.title}}" class="docimg2" />
              </div>
            </div>
          </div>
        </div>
      </div>
       
      <div class="list-header">
        <h2>List Of Connections</h2>
        <div class="header-actions" *ngIf="!connectionKey && !profileKey">
          <div class="country-selector" (click)="addressBook()">
            <i class="fa fa-address-book" aria-hidden="true"></i>
            <span>Address Book</span>
          </div>
          <button
            class="add-new-btn"
            mat-raised-button
            [matMenuTriggerFor]="menu"
            #menuTrigger="matMenuTrigger">
            <span class="btn-text">Add New</span>
            <i class="material-icons expand-icon">{{ menuTrigger.menuOpen ? 'expand_less' : 'expand_more' }}</i>
          </button>
          <mat-menu #menu="matMenu">
            <button class="actionBtn" *ngFor="let option of dropdownOptions"  mat-menu-item (click)="option.action()">
              <i *ngIf="option.iconType === 'fa'" [ngClass]="option.icon" aria-hidden="true"></i>&nbsp;
              <span>{{ option.label }}</span>
            </button>
          </mat-menu>
        </div>
      </div>
  
      <!-- List Section -->
      <div class="document-list" *ngIf="!connectionKey && !profileKey" [ngStyle]="viewMode === 'list' ? {'overflow': 'scroll', 'height': '250px', 'padding-bottom': '220px'} : {}">
        <div class="search-section">
          <div class="search-container">
            <i class="material-icons">search</i>
            <input class="search-text" type="text" placeholder="Search for Connection..." 
            [(ngModel)]="searchQuery" >
          </div>

           <!-- Sort & view -->
          <div class="view-options">
          <button class="sort-btn" mat-raised-button [matMenuTriggerFor]="sortMenu">
            <i class="material-icons">sort</i>
          </button>
          
          <mat-menu #sortMenu="matMenu">
            <button *ngFor="let option of sortConnections" mat-menu-item (click)="option.action()">
                <i class="{{ option.icon }}" style="margin-right: 8px; font-size: 20px; -webkit-text-stroke: 0.5px; vertical-align: middle;"></i>
              <span>{{ option.label }}</span>
            </button>
          </mat-menu>

            <button class="view-btn" (click)="toggleView()">
              <i class="material-icons">{{ viewMode === 'grid' ? 'grid_view' : 'view_list' }}</i>
            </button>
          </div>
          <!-- Sort & view -->
        </div>
    
        <!-- Display Contacts -->
        <ng-container *ngIf="list.length > 0; else emptyState">
          <!-- Show Contact Cards -->
          <!-- GRID VIEW -->
          <div *ngIf="viewMode === 'grid'" class="contact-cards-container2">
            <div class="contact-card2" *ngFor="let contact of list | filter:searchQuery"
              [class.disabled]="contact.status !== 'accepted' && contact.status !== 'accepted_by_consumer'"
              (click)="contact.status === 'accepted' || contact.status === 'active' || contact.status === 'accepted_by_consumer' ? profilePage(contact) : null">

              <div class="status-badge2" *ngIf="(contact.status === 'accepted' || contact.status === 'active' || contact.status === 'accepted_by_consumer' ) && contact.canAccept == false">Active</div>
              
              <div class="avatar2" *ngIf="!contact.profile_url">
                {{ contact.business_name?.charAt(0).toUpperCase() }}
              </div>
              <img *ngIf="contact.profile_url" [src]="contact.profile_url" class="profile-img" />

              <div class="contact-details2">
                <h4>{{ contact.business_name }}</h4>
                <p *ngIf="contact.status === 'accepted' || contact.status === 'active' || contact.status === 'accepted_by_consumer'">{{ contact.email }}</p>
              </div>

              <button *ngIf="contact.canAccept && !contact.isaccepted" class="status-accept" (click)="acceptRequest(contact.id,contact.biztype)">
                Accept
              </button>
              <button *ngIf="!contact.canAccept && !contact.isaccepted" class="status-pending">
                Pending
              </button>
              
              <div class="icon-actions" *ngIf="contact.status === 'accepted' || contact.status === 'active' || contact.status === 'accepted_by_consumer'">
                <i class="far fa-comment-dots icon-btn" (click)="chatProfile()"></i>
                <i class="far fa-share-square icon-btn" (click)="shareProfile(contact)"></i>
              </div>
            </div>
          </div>

          <!-- LIST VIEW -->
          <div *ngIf="viewMode === 'list'" class="doc-list-view">
            <table class="doc-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email Address</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let contact of list | filter:searchQuery">
                  <td>
                    <div class="doc-name-cell">
                      <div class="listavatar" *ngIf="!contact.profile_url">
                        {{ contact.business_name?.charAt(0).toUpperCase() }}
                      </div>
                      <img *ngIf="contact.profile_url" [src]="contact.profile_url" class="profile-img listimg" />
                      {{ contact.business_name }}
                    </div>
                  </td>
                  <td *ngIf="contact.status === 'accepted' || contact.status === 'active' || contact.status === 'accepted_by_consumer'">{{contact.email}}</td>
                  <td> 
                    <button *ngIf="contact.canAccept && !contact.isaccepted" class="status-accept"
                      (click)="acceptRequest(contact.id,contact.biztype)">
                      Accept
                    </button>
                    <button *ngIf="!contact.canAccept && !contact.isaccepted" class="status-pending">
                      Pending
                    </button>
                    <button *ngIf="contact.status === 'accepted' || contact.status === 'active' || contact.status === 'accepted_by_consumer'" class="status-active-word">
                      Active
                    </button>
                  </td>
                  <td>
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item routerLink="/chats" [disabled]="!isContactAccepted(contact)"><i class="far fa-comment-dots icon-btn3"></i> &nbsp;Chat</button>
                      <button mat-menu-item (click)="profilePage(contact);shareProfile(contact)" [disabled]="!isContactAccepted(contact)"><i class="far fa-share-square icon-btn3"></i> &nbsp;Share</button>
                    </mat-menu>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

       </ng-container>
  
        <!-- Empty State -->
        <ng-template #emptyState>
          <div class="empty-state">
            <div class="upload-illustration">
              <img class="docimg" src="assets/images/ConnectionBB.png" alt="Add Connections">
            </div>
            <h3 class="emptyconn">No Connections Yet..</h3>
            <p class="exNetwork">Expand your network to stay connected with your digital relationships.</p>
            <button class="add-documents-btn" (click)="onAddConnection()">Add Connection</button>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Address Book -->
    <div class="main-content goback" *ngIf="connectionKey">
      

      <div class="list-header lsh">
        <!-- <h2>Saved Contacts</h2> -->
         <h2 style="color: black;"><i class="fa fa-arrow-left" aria-hidden="true" (click)="goBack()"></i> &nbsp; 
          Saved Contacts ({{ entity_list?.length ?? 0 }})</h2>
          <!-- <h2>  </h2> -->
        <div class="header-actions">
          <!-- <div class="country-selector" (click)="addressBook()">
            <i class="fa fa-address-book" aria-hidden="true"></i>
            <span>Address Book</span>
          </div> -->
          <button
            class="add-new-btn"
            mat-raised-button
            [matMenuTriggerFor]="menu"
            #menuTrigger="matMenuTrigger"
          >
            <span class="btn-text">Add New</span>
            <i class="material-icons expand-icon">{{ menuTrigger.menuOpen ? 'expand_less' : 'expand_more' }}</i>
          </button>
          <mat-menu #menu="matMenu">
            <button class="actionBtn" *ngFor="let option of dropdownOptions"  mat-menu-item (click)="option.action()">
              <i *ngIf="option.iconType === 'fa'" [ngClass]="option.icon" aria-hidden="true"></i>&nbsp;
              <span>{{ option.label }}</span>
            </button>
          </mat-menu>
        </div>
      </div>

      <!-- List Section -->
      <div class="document-list">
        <div class="search-section">
          <div class="search-container">
            <i class="material-icons">search</i>
            <input class="search-text" type="text" placeholder="Search for Contact..." 
                   [(ngModel)]="searchRel">
          </div>

          <!-- sort -->
          <div class="view-options">
            <button class="sort-btn" mat-raised-button [matMenuTriggerFor]="sortMenu">
              <i class="material-icons">sort</i>
            </button>
          
            <mat-menu #sortMenu="matMenu">
              <button *ngFor="let option of sortContacts" mat-menu-item (click)="option.action()">
                <i class="material-icons">{{option.icon}}</i>
                <span>{{ option.label }}</span>
              </button>
            </mat-menu>
          </div>
          <!-- sort -->
          
        </div>
    
        <!-- Display Contacts -->
        <ng-container *ngIf="entity_list?.length; else noRelationshipsTemplate">

           <!-- Show Contact Cards -->
          <div class="contact-cards-container">
            <div class="contact-card" *ngFor="let contact of entity_list | filter:searchRel">
              <div class="avatar">
                {{ contact.name?.charAt(0).toUpperCase() }}
              </div>
              <div class="contact-details">
                <h4>{{ contact.name }}</h4>
                <p>{{ contact.email }}</p>
              </div>
              <div class="contact-actions">
                <button mat-icon-button (click)="onEditContact(contact)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button (click)="onDeleteContact(contact)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Empty State -->
        <ng-template #noRelationshipsTemplate>
          <div class="empty-state es2">
            <div class="upload-illustration">
              <img class="docimg" src="assets/images/addcontact.png" alt="Add Connections">
            </div>
            <h3 class="emptyconn">No Contact Saved Yet..</h3>
            <p class="exNetwork">Your saved contacts will be displayed here once added.</p>
            <button class="add-documents-btn" (click)="onAddContact()">Add Contact</button>
          </div>
        </ng-template>
      </div>

    </div>

    <!-- Profile Page -->   
    <div class="main-content" *ngIf="profileKey">
      <div class="profile-container"> 

        <div class="profile-card"> 
          <h2 class="profile-title"> <img class="backo" (click)="goBacktoConnections()" src="assets/images/leftArrow.png"> PROFILE</h2>

          <div class="profile-header">       
            <!-- Show image if available, otherwise fallback avatar -->
            <ng-container *ngIf="selectedProfile?.profileUrl; else showInitial">
              <img 
                [src]="selectedProfile.profileUrl" 
                [alt]="selectedProfile.business_name" 
                class="avatar" />
            </ng-container>
            
            <ng-template #showInitial>
              <div class="avatar-text">
                {{ selectedProfile?.business_name?.charAt(0).toUpperCase() }}
              </div>
            </ng-template>
      
            <div class="profile-info">
              <h2 class="name">{{ selectedProfile?.business_name }}</h2>
              <p class="email">{{ selectedProfile?.email }}</p>
              <a (click)="toggleDetails()" class="toggle-link">
                View details   <i class="fa" [ngClass]="showDetails ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
              </a>
            </div>
          </div>
    
          <div class="details" *ngIf="showDetails">
            <div class="detail-row">
              <i class="fas fa-map-marker-alt icon"></i>
              <div class="detail-label-group">
                <strong>Address:</strong>
                <p class="detail-value">{{ selectedProfile?.address || 'N/A' }}</p>
              </div>
            </div>
            <div class="detail-row">
              <i class="fas fa-th-large icon"></i>
              <div class="detail-label-group">
                <strong>Category:</strong>
                <p class="detail-value">{{ selectedProfile?.tags[0] || 'N/A' }}</p>
              </div>
            </div>
            <div class="detail-row">
              <i class="fas fa-globe icon"></i>
              <div class="detail-label-group">
                <strong>Country:</strong>

                <div class="country-display">
                  <img [src]="getFlagUrl(selectedProfile?.country)" [alt]="selectedProfile?.country + ' Flag'" class="flag-icon" *ngIf="getFlagUrl(selectedProfile?.country)" />
                  <p class="detail-value">{{ selectedProfile?.country || 'N/A' }}</p>
                </div>

              </div>
            </div>
            <div class="detail-row">
              <i style="transform: rotateY(180deg);" class="fa fa-phone icon"></i>
              <div class="detail-label-group">
                <strong>Mobile:</strong>
                <p class="detail-value">{{ selectedProfile?.mobile || 'N/A' }}</p>
              </div>
            </div>
          </div>

        </div>
    
        <div class="shared-folder-card">
          <h2 class="section-title">SHARED FOLDER - DOCUMENTS
          <button class="add-new-btn" (click)="shareDocuments()">
            <span class="btn-text">Share Documents <i class="far fa-share-square icon-btn2"></i></span>
          </button>
         </h2>

          <!-- shared by me/with me-->
          <div class="tabs">
            <div class="tab" [class.active]="activeTab === 'with'" (click)="loadFiles('with')">
              Shared With Me ({{ filesSharedWith?.length || 0 }})
            </div>
          
            <div class="tab" [class.active]="activeTab === 'by'" (click)="loadFiles('by')">
              Shared By Me ({{ filesSharedBy?.length || 0 }})
            </div>
          </div>
          <!-- shared by me/with me-->

          <!-- Search Section -->
          <div class="search-section">
          <div class="search-container">
            <i class="material-icons">search</i>
            <input class="search-text" type="text" placeholder="Search for Document..." 
            [(ngModel)]="searchQuery">
          </div>
          </div>
          <!-- Search Section -->        
    
          <div style="overflow: scroll;height: 280px;">
          <div class="file-card" *ngFor="let file of files | filter:searchQuery">
            <div class="file-info">
             <img src="assets/images/file.svg" alt="Upload">
              <div>
                <div class="file-name">{{ getDoctypeName(file.docname) }}</div>
                <div class="file-desc">{{ file.description }}</div>
              </div>
            </div>
            <!-- <i class="fa fa-ellipsis-v more-icon"></i> -->
                         
            <!-- Actions Column -->
            <button mat-icon-button [matMenuTriggerFor]="actionMenu" *ngIf="activeTab === 'with'">
              <i class="material-icons">more_vert</i>
            </button>
            <mat-menu #actionMenu="matMenu">
              <button mat-menu-item (click)="onDocumentAction('view', file)">
                <mat-icon>visibility</mat-icon>
                <span>View</span>
              </button>
              <button mat-menu-item (click)="onDocumentAction('download', file)">
                <mat-icon>download</mat-icon>
                <span>Download</span>
              </button>
              <!-- <button mat-menu-item (click)="onDocumentAction('delete', doc)">
                    <mat-icon>delete</mat-icon>
                    <span>Delete</span>
                  </button> -->
            </mat-menu>

            <button *ngIf="activeTab === 'by'" class="unbtn" (click)="unshare(file)" title="Stop sharing this document">
      <i class="bi bi-x-circle unshare"></i>
    </button>
             
          </div>
          </div>
        </div>
    
      </div>
    </div>
</div>


<!-- Document Preview Modal -->
  <div *ngIf="isPreviewOpen" class="preview-modal">
    <div class="preview-content">
      <div class="preview-header">
        <h2>{{previewDocument?.name}}</h2>
        <button mat-icon-button (click)="closePreview()">
          <i class="material-icons">close</i>
        </button>
      </div>
      <div class="preview-body">
        <!-- 🌀 Spinner overlay -->
        <div *ngIf="isLoading" class="spinner-overlay">
          <mat-spinner diameter="40"></mat-spinner>
        </div>

        <ng-container *ngIf="previewDocument" >

         
          <img
                  *ngIf="isImage(previewDocument.mimeType)"
                  [src]="previewDocument.previewUrl"
                  [alt]="previewDocument.name"
                  class="preview-image" 
                  (load)="onPreviewLoad()"
                  />
          <iframe width="98%" margin-top="20px" height="80%" *ngIf="previewDocument.mimeType === 'application/pdf'" [src]="previewDocument.previewUrl" frameborder="0"
        (load)="onPreviewLoad()"></iframe>
          <!-- <div *ngIf="!isImage(previewDocument.mimeType) && previewDocument.mimeType !== 'application/pdf'" class="no-preview">
            <img class= "docmat" src="assets/images/docs.png" alt="document icon">
            <p>Preview not available for this file type</p>
          </div> -->
        </ng-container>
      </div>
    </div>
  </div>
<!-- Document Preview Modal -->